<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="exampleModalLabel1">Editar Conexion</h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      mat-dialog-close
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <form [formGroup]="form">
      <!-- Nombre -->
      <mat-form-field style="width: 100%;">
        <mat-label>Cantidad</mat-label>
        <input
          type="text"
          formControlName="cantidad"
          matInput
          placeholder="Ingrese su cantidad"
        />
        <mat-error *ngIf="form.get('cantidad').hasError('required')"
          >La cantidad es <strong>requerida</strong></mat-error
        >
      </mat-form-field>
      <br />
      <button
        class="btn btn-info waves-effect float-right"
        [mat-dialog-close]="form.value"
        [disabled]="form.status != 'VALID'"
      >
      <i class="far fa-save"></i>
        Guardar
      </button>
    </form>
  </div>
</div>
